<template>
    <div>
        <v-form ref="form" class="p-2">
            <v-row dense> 
                <v-col xs="12" sm="12" md="6" lg="6" xl="6">
                    <v-text-field
                        v-model="localFilters.name"
                        label="Nome"
                        outlined
                        dense
                        clearable
                    />
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <v-select
                        v-model="localFilters.profile"
                        :items="items.profiles"
                        label="Perfil"
                        outlined
                        dense 
                        clearable
                    ></v-select>
                </v-col>
            </v-row>
            <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" class="text-right">
                    <v-btn
                        color="primary"
                        @click.prevent="submit"
                        :block="this.$vuetify.breakpoint.smAndDown"
                    >
                    Pesquisar
                    </v-btn>
                </v-col>  
            </v-row>
        </v-form>        
    </div>
</template>

<script>
import { PROFILES } from '../config_users/config_users.js'

export default {
    props: {
        initialParams: {
            type: Object,
            default: () => ({
                id: '',
                page: 1
            })
        }
    },

    watch: {
        initialParams: {
            handler(newVal) {
                if (newVal) {
                    this.localFilters = { ...newVal };
                }
            },
            immediate: true
        },
    }, 

    data() {
        return {
            localFilters: {
                id: ''
            },
            
            items: {
                profiles: PROFILES
            },
        }
    },

    methods: {

        clear() {
            this.$refs.form.reset()
        },

        submit(){
            this.localFilters.id = ''
            this.$emit('callLoadItems',this.localFilters)
        },
    }
}
</script>